import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from './portal-accounts-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-all-portal-users')) {
  ReactDOM.render(<PortalAccountsTable
    url= "/api/v1/portal/portal-admin/all-portal-users"
    message_if_none = 'No portal accounts yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-all-portal-users'));
}
